import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  popover: null,
  pinnedPopover: null,
  incidentPopover: null,
};

const mapPopoverSlice = createSlice({
  name: 'mapPopoverSlice',
  initialState,
  reducers: {
    showPopover(state, action) {
      const { payload } = action;
      state.popover = payload;
    },
    hidePopover(state) {
      state.popover = null;
    },
    showPinnedPopover(state, action) {
      const { payload } = action;
      state.pinnedPopover = payload.loc;
    },
    hidePinnedPopover(state) {
      state.pinnedPopover = null;
    },
    showIncidentPopover(state, action) {
      const { payload } = action;
      state.incidentPopover = payload;
    },
    hideIncidentPopover(state) {
      state.incidentPopover = null;
    },
  },
});

export const {
  showPopover,
  hidePopover,
  showPinnedPopover,
  hidePinnedPopover,
  showIncidentPopover,
  hideIncidentPopover,
} = mapPopoverSlice.actions;
export default mapPopoverSlice.reducer;
